import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1b23fe3f = () => interopDefault(import('../src/pages/course-directory/index.vue' /* webpackChunkName: "pages/course-directory/index" */))
const _22eded3b = () => interopDefault(import('../src/pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _ae595de4 = () => interopDefault(import('../src/pages/logout/index.vue' /* webpackChunkName: "pages/logout/index" */))
const _a653d842 = () => interopDefault(import('../src/pages/onboarding/index.vue' /* webpackChunkName: "pages/onboarding/index" */))
const _7696131c = () => interopDefault(import('../src/pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _836f95a2 = () => interopDefault(import('../src/pages/onboarding/welcome.vue' /* webpackChunkName: "pages/onboarding/welcome" */))
const _6ff480b2 = () => interopDefault(import('../src/pages/qa/internal_email/content.vue' /* webpackChunkName: "pages/qa/internal_email/content" */))
const _3cf74c58 = () => interopDefault(import('../src/pages/tools/admin/token.vue' /* webpackChunkName: "pages/tools/admin/token" */))
const _4a0e7bb3 = () => interopDefault(import('../src/pages/byte/pause/_secret/index.vue' /* webpackChunkName: "pages/byte/pause/_secret/index" */))
const _bc26e364 = () => interopDefault(import('../src/pages/byte/unsubscribe/_secret/index.vue' /* webpackChunkName: "pages/byte/unsubscribe/_secret/index" */))
const _b4faf902 = () => interopDefault(import('../src/pages/newsletter/unsubscribe/_secret/index.vue' /* webpackChunkName: "pages/newsletter/unsubscribe/_secret/index" */))
const _71d66808 = () => interopDefault(import('../src/pages/tools/company/_companyId/security/manage-admins.vue' /* webpackChunkName: "pages/tools/company/_companyId/security/manage-admins" */))
const _0d49a4be = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/course-directory",
    component: _1b23fe3f,
    pathToRegexpOptions: {"strict":true},
    name: "course-directory"
  }, {
    path: "/login",
    component: _22eded3b,
    pathToRegexpOptions: {"strict":true},
    name: "login"
  }, {
    path: "/logout",
    component: _ae595de4,
    pathToRegexpOptions: {"strict":true},
    name: "logout"
  }, {
    path: "/onboarding",
    component: _a653d842,
    pathToRegexpOptions: {"strict":true},
    name: "onboarding"
  }, {
    path: "/signup",
    component: _7696131c,
    pathToRegexpOptions: {"strict":true},
    name: "signup"
  }, {
    path: "/onboarding/welcome",
    component: _836f95a2,
    pathToRegexpOptions: {"strict":true},
    name: "onboarding-welcome"
  }, {
    path: "/qa/internal_email/content",
    component: _6ff480b2,
    pathToRegexpOptions: {"strict":true},
    name: "qa-internal_email-content"
  }, {
    path: "/tools/admin/token",
    component: _3cf74c58,
    pathToRegexpOptions: {"strict":true},
    name: "tools-admin-token"
  }, {
    path: "/byte/pause/:secret",
    component: _4a0e7bb3,
    pathToRegexpOptions: {"strict":true},
    name: "byte-pause-secret"
  }, {
    path: "/byte/unsubscribe/:secret",
    component: _bc26e364,
    pathToRegexpOptions: {"strict":true},
    name: "byte-unsubscribe-secret"
  }, {
    path: "/newsletter/unsubscribe/:secret",
    component: _b4faf902,
    pathToRegexpOptions: {"strict":true},
    name: "newsletter-unsubscribe-secret"
  }, {
    path: "/tools/company/:companyId?/security/manage-admins",
    component: _71d66808,
    pathToRegexpOptions: {"strict":true},
    name: "tools-company-companyId-security-manage-admins"
  }, {
    path: "/",
    component: _0d49a4be,
    pathToRegexpOptions: {"strict":true},
    name: "index"
  }, {
    path: "/auth"
  }, {
    path: "/learn/directory*",
    component: _1b23fe3f,
    name: "learn-directory"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
